export enum FormTypes {
  SelfReferral = 1,
  PartnerReferral = 2,
  PostVisit = 3,
  PDIR = 4,
  Sfrs = 5
}
